import {connect} from 'react-redux';
import ActiveConsentList from "./ActiveConsentsList";
import {MODAL_REMOVE_ACTIVE_CONSENT, showModal} from "../../../../reducers/common/activeModal";
import {getTranslation} from "../../../../reducers/common/localization";
import {
    getConsentsList, getRequestsByStatus, GRANTED,
    loadingConsents
} from "../../../../reducers/consent/consents";
import {fetchUpdateConsent} from "../../../../reducers/consent/consent";

const mapStateToProps = state => {
    return {
        translation: getTranslation(state),
        data: getConsentsList(state),
        loading: loadingConsents(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: () => dispatch(getRequestsByStatus(GRANTED)),
        onRemove: (id, data) => dispatch(fetchUpdateConsent(id, data)),
        onRemoveButtonClick: () => dispatch(showModal({modalKey: MODAL_REMOVE_ACTIVE_CONSENT}))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ActiveConsentList);



// WEBPACK FOOTER //
// ./src/components/consentManagement/consentsList/activeConsentsList/ActiveConsentsList.container.js